<svg>
	<g>
		<rect x="0" y="0" width="400" height="400"
		 [attr.fill]="myFill" (click)="changeColor()" />
		<text x="120" y="50">click the rectangle to change the fill color</text>		
</g>
</svg>